
import AboutSection from './AboutSection'
import ComprehensiveServices from './ComprehensiveServices'
import ContactSection from './ContactSection'
import DeveloperChallenge from './DeveloperChallenge'
import HeroSection from './HeroSection'
import Mission from './Mission'
import SalesCTA from './SalesCTA'
import ServicesSection1 from './ServicesSection1'
import StrategicAlliances from './StrategicAlliances'
import WhyDevelopers from './WhyDeveloper'


const index = () => {
  return (
    <div>
        <HeroSection/>
        <AboutSection/>
        <Mission/>
        <DeveloperChallenge/>
        <StrategicAlliances/>
        {/* <ServicesSection/> */}
        <ServicesSection1/>
        <ComprehensiveServices/>
        <WhyDevelopers/>
        <SalesCTA/>
        <ContactSection/>
    </div>
  )
}

export default index